import { productMetafieldDefinitionSchema } from "@redotech/shopper-agent-knowledge-common/product-metafield-view";
import * as z from "zod";

/**
 * The Shopify product metafields this account has defined, for the picker that
 * chooses which of them the agent may read. Empty when IMS sync is off.
 */
export const listProductMetafieldDefinitions = {
  name: "listProductMetafieldDefinitions" as const,
  input: z.object({}),
  output: z.object({ definitions: z.array(productMetafieldDefinitionSchema) }),
};
